<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path d="M11 3.6L9.462 2 4.846 6.8 2.538 4.4 1 6l3.846 4L11 3.6z"/></svg>